import React from "react";
import styles from "./NotAvailableCellData.module.scss"

const NotAvailableCellData = () => {
    return <span className={styles.base}>N/A</span>
}

export default NotAvailableCellData;
